export const LAB_LIST_REQUEST = "LAB_LIST_REQUEST";
export const LAB_LIST_SUCCESS = "LAB_LIST_SUCCESS";
export const LAB_LIST_FAIL = "LAB_LIST_FAIL";
